import { FIT_MODAL_CLASS } from '../constants';
import { PAGE_NAME } from '../events';

const contextEnrichment = ({
    carouselPosition,
    collections,
    isLoggedIn,
    isTouch,
    updateCollections,
    general,
    requestContext,
    currencyConverter,
    source,
    carouselContext = 'recommendation',
    ref
}) => {
    const { page_ctx_id } = requestContext;
    const currentUser = isLoggedIn ? requestContext.current_user : {};

    return ({
        gigCollect: {
            gigCollectProps: {
                currentUser,
                showCollMenu: true,
                updateCollections,
                modalCustomName: FIT_MODAL_CLASS
            },
            collections: collections.collections
        },
        impressionEnrichment: {
            listings: {
                carousel_position: carouselPosition,
                page_ctx_id
            }
        },
        context: {
            queryParameters: {
                context: carouselContext,
                ref
            },
            sourcePage: PAGE_NAME,
            sourceComponent: source,
            currency: currencyConverter.getCurrency(),
            pageCtxId: page_ctx_id,
            userId: currentUser.id,
            subCategory: general.subCategorySlug,
            viewportType: 'gigs.show',
            currentPage: 'Gig page',
            controllerAction: 'gigs#show'
        },
        isTouch
    });
};

export default contextEnrichment;
